export const SOLUTION_SUCCESS = 'SOLUTION_SUCCESS'
export const SOLUTION_FAILURE = 'SOLUTION_FAILURE'

export const solutionData = (solution) =>{
  return (dispatch, getState) => {
    dispatch({ type: SOLUTION_SUCCESS,solution });
  }
}
